import apiConfig from "../config";
import axios from "axios";


const getCategories = async () => {
    try {
        const response = await axios.get(`${apiConfig.apiUrl}/categories`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching categories:", error);
        return null;
    }
};

const getCategoryDetails = async (categoryId) => {
    try {
        const response = await axios.get(`${apiConfig.apiUrl}/Category/Details/${categoryId}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching category details:", error);
        return null;
    }
};

const getCmsContent = async (categoryId, optionId, plan) => {
    try {
        const params = {};
        if (categoryId) params.categoryId = categoryId;
        if (optionId) params.optionId = optionId;
        if (plan) params.plan = plan;

        const response = await axios.get(`${apiConfig.apiUrl}/Cms`, {
            params: params,
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching CMS content:", error);
        return null;
    }
};

const getMostConsultedCategories = async () => {
    try {
        const response = await axios.get(`${apiConfig.apiUrl}/Categories/MostConsulted`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching most consulted categories:", error);
        return null;
    }
};

const getPlansByOption = async (optionId) => {
    try {
        const response = await axios.get(`${apiConfig.apiUrl}/Cms/Plans/${optionId}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching plans by option:", error);
        return null;
    }
};

const getContentByPlan = async (plan) => {
    try {
        const response = await axios.get(`${apiConfig.apiUrl}/Cms/Plan/${plan}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching content by plan:", error);
        return null;
    }
};

export { getCategories, getCategoryDetails, getCmsContent, getMostConsultedCategories, getPlansByOption, getContentByPlan };

